import { TableColumnsSetting } from '@/interfaces/table-setting';

export class SellerPracticeInvoiceSettingsTable {
  public static getColumnsSetting(): TableColumnsSetting<any> {
    return [
      {
        name: 'importoNetto',
        text: 'Importo Netto',
        type: 'currency',
      },
      {
        name: 'percentualeIva',
        text: 'Percentuale IVA',
      },
    ];
  }
}
